import { createSlice } from '@reduxjs/toolkit';

type LessonTemplatesType = {};

const initialState: LessonTemplatesType = {};

export const homeTasksSlice = createSlice({
  name: 'homeTasks',
  initialState,
  reducers: {},
});

export const {} = homeTasksSlice.actions;
